import React from 'react'
import { reduxForm, Field } from 'redux-form'
import { TextInput  } from '../../../components/forms/index'
import Button from '@atlaskit/button'

const UserEmulatorForm = (props) => {
    let { handleSubmit, actionInProgress, userCheckResults } = props
    return (
        <form onSubmit={handleSubmit}>
            <div className='access-user-check-container'>
                <Field                     
                    key='UserId'
                    name='UserId'
                    component={TextInput}            
                    label='Nike Username or Email address'
                    title="Enter the Nike username or email address of the user you want to emulate."
                    placeholder='˜Nike Username or Email'
                    disabled={actionInProgress || userCheckResults === true}
                    className='pt4-sm ncss-input pr4-sm pb2-sm pl4-sm'/>
                {userCheckResults != true ? userCheckResults : null}
                <Button type='submit' appearance='primary' isLoading={actionInProgress} className='search-form-btn'>
                    {userCheckResults === true ? null : <i className='g72 g72-search' />}{userCheckResults === true? 'Emulate' : ' Check' }
                </Button>
            </div>
        </form>
    )
}

const validate = (values) => {
     return !values.UserId ? 'You need to enter a Nike username or Email address' : undefined
    }
  
export default reduxForm({
    form: 'UserEmulatorForm',    
    validate: validate,    
})(UserEmulatorForm)



// WEBPACK FOOTER //
// ./client/src/admin/tools/userEmulator/UserEmulatorForm.js